<div class="task-layout">
    <header class="task-layout__header">
        <div class="task-layout__banner">
            @if (activePositionTitle$ | async; as title) {
                <pf-text type="title" class="task-layout__title">{{
                    title
                }}</pf-text>
            }
            <ng-content select="[banner]"></ng-content>
        </div>
        <ng-content select="[header]"></ng-content>
    </header>
    <main class="task-layout__content">
        <ng-content select="[content]"></ng-content>
    </main>
</div>
